import axios from 'axios'
import { OPEN_FINANCE_API_ENDPOINT } from 'shared/envs'

import { httpClientFactory } from '~/domains/platform/infra/http/http-client-factory'
import { keysToSnakecase, transformResponse } from '~/domains/platform/infra/http/http-helpers'
import { responseUnauthorizedAccessInterceptor } from '~/domains/platform/infra/http/interceptors/unauthorized-access-interceptor'

export const httpClientOpenFinance = httpClientFactory({
  baseURL: OPEN_FINANCE_API_ENDPOINT(),
  transformRequest: [keysToSnakecase, ...(axios.defaults.transformRequest as any[])],
  transformResponse: [...(axios.defaults.transformResponse as any[]), transformResponse],
  responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
})
